var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscriptionMedia28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#subscription_media_28)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.774 19.288a5.34 5.34 0 0 0 1.57-3.788c0-3.515-2.956-6.734-4.477-8.158-.347-.325-.886-.068-.915.407-.293 4.84-2.424 4.533-3.339 4.17-.252-.1-.555-.072-.73.136A5.336 5.336 0 0 0 8.63 15.5c0 1.48.6 2.819 1.569 3.788a5.34 5.34 0 0 0 3.788 1.57c1.48 0 2.819-.6 3.788-1.57Zm-2.172-1.409c.414-.427.67-1.018.67-1.67 0-1.181-.762-2.277-1.27-2.877-.161-.19-.45-.071-.47.177-.195 2.42-1.493 2.568-2.201 1.986-.18-.147-.489-.14-.549.085-.053.2-.082.411-.082.629 0 .652.256 1.243.67 1.67.414.428.985.692 1.616.692.631 0 1.203-.264 1.616-.692Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription_media_28",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8040"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionMedia28);
export default __webpack_public_path__ + "static/media/subscription_media_28.54e9ba25.svg";
export { ForwardRef as ReactComponent };